module.exports = __webpack_public_path__ + "media/icons/naped-przod-active-34e46ce0.png";